import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./VerificationsCategory.scss";
import _ from "lodash";
import Helmet from "react-helmet";
import {config} from "../../../../config";
import {fetchCategoriesModeVideo} from "../../../../creators/tagModerations.categoriesModeVideo";
import MediaVideo from "./Components/MediaVideo/MediaVideo";




class TagModerationVerificationCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.categoryId = _.get(this.props, "match.params.categoryId") || null;
        this.goBackUrl = _.get(this.props, "match.url").replace(`-video/${this.categoryId}`, "") || "/";
        this.currentCategory = {};
        this.props.fetchCategoriesModeVideo()
    }

    componentWillUnmount() {

    }

    render() {
        if(this.props.categoriesModeVideoInitialized){
            let category = this.props.categoriesModeVideo.filter(cat => cat._id.toString() === this.categoryId);
            if(category){
                this.currentCategory = category[0];
            }
        }
        return (
            <div id="tag-moderations-verification-category">
                <Helmet>
                    <title>{config.preTitle} Tag Moderations {config.postTitle}</title>
                </Helmet>

                <div className={"container"}>
                    <div className="card">
                        {this.props.categoriesModeVideoInitialized && this.currentCategory?._id ? <MediaVideo currentCategory={this.currentCategory} goBackUrl={this.goBackUrl}/> : null}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesModeVideo: state.categoriesModeVideo.data,
        categoriesModeVideoInitialized : state.categoriesModeVideo.initialized,
        categoriesModeVideoLoading : state.categoriesModeVideo.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoriesModeVideo
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagModerationVerificationCategory);